// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
require("packs/maskMoney")
require('inputmask')

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import * as bootstrap from 'bootstrap'

document.addEventListener('DOMContentLoaded', function (event) {
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
})

window.money = function() {
  $('.currency').maskMoney({thousands:'.', decimal:',', affixesStay: false});
}

window.loadButton = function(btn, cost) {
  if(cost != '') {
    btn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>'
    var new_class = btn.getAttribute('class')
    new_class += ' disabled'
    btn.setAttribute('class', new_class)
  }
}

window.setLoad = function() {
  var mainContainer = document.getElementById('main-container')
  if (mainContainer) mainContainer.classList.remove('d-none')
}

window.hideLoad = function() {
  var mainContainer = document.getElementById('main-container')
  if (mainContainer) mainContainer.classList.add('d-none')
}

$(document).on('turbolinks:load', function () {
  hideLoad()

  var cpfMask = new Inputmask('999.999.999-99');
  var birthdateMask = new Inputmask('99/99/9999');
  var phoneMask = new Inputmask('(99) 99999-9999');

  var documentSelector = $('#person_document');
  var birthdateSelector = $('#user_birth_date');
  var phoneSelector = $('#user_phone');

  cpfMask.mask(documentSelector);
  birthdateMask.mask(birthdateSelector);
  phoneMask.mask(phoneSelector);
});

document.addEventListener('turbolinks:before-render', hideLoad)
document.addEventListener('turbolinks:before-cache', hideLoad)
window.addEventListener('pageshow', hideLoad)
